const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const visitedMonth = []; //saturdays = [],

let _callClick, _selectDate, _unselectDate, prj, parcel, address, moveoutDate, startDate, endDate, clickModel, schedules, staticEvents, inited, maxPermitDays, dateSelected;
const addDays = (date, days) => {
  var _date = new Date(date);
  _date.setDate(_date.getDate() + days);
  return _date;
}
const setMaxPermitDuration = permits => {
  let maxDuration = 0;
  permits.forEach(val => {
    if (maxDuration < val.duration) {
      maxDuration = val.duration;
    }
  });

  maxPermitDays = maxDuration * 7;

  var sd = new Date();
  sd.setHours(0, 0, 0, 0);
  var ed = new Date(sd);
  ed.setDate(ed.getDate() + maxPermitDays);
  ed.setHours(23, 59, 59, 0);
  if (moveoutDate > ed) {
    ed = new Date(moveoutDate);
    maxPermitDays = Math.ceil((ed.getTime() - sd.getTime()) / (1000 * 3600 * 24));
  }

  while (sd.getDay() !== 0) {
    sd.setDate(sd.getDate() - 1);
  }
  while (ed.getDay() !== 0) {
    ed.setDate(ed.getDate() - 1);
  }

  while (sd < ed) {
    var sd1 = new Date(sd);
    sd1.setDate(sd1.getDate() + 1);
    var ed1 = new Date(sd);
    ed1.setDate(ed1.getDate() + 5);
    schedules.push({ start: sd1, end: ed1, isPermit: true });
    sd.setDate(sd.getDate() + 7);
  }
};

const findDays = (w, d1, d2) => {
  var date = new Date(d1);
  var endDate = d2 || getViewEndDate();

  var w1 = date.getDay();
  date.setDate(date.getDate() + w - w1);

  var days = [];

  while (date <= endDate) {
    days.push(new Date(date.getTime()));
    date.setDate(date.getDate() + 7);
  }

  return days;
};

const getMonday = d => {
  var w = d.getDay();
  var d1 = new Date(d);
  d1.setDate(d1.getDate() + 1 - w);
  return d1;
}

const addUnavail = m => {
  var sd1 = new Date(m);
  var ed1 = new Date(m);
  ed1.setDate(ed1.getDate() + 6);
  schedules.push({ start: sd1, end: ed1, isUnavail: true });
}

const getStartDate = () => {
  var date = new Date();
  date.setHours(8, 0, 0, 0);
  var curMonday = getMonday(date);

  var d = maxPermitDays;
  var permitStartDay = new Date(date);
  permitStartDay.setDate(permitStartDay.getDate() + d);
  var permitMonday = getMonday(permitStartDay);

  var diff = Math.floor((permitMonday - curMonday) / 86400000) / 7;

  var sd = new Date(curMonday);
  if (diff == 0) addUnavail(sd);
  sd.setDate(sd.getDate() + 7);
  if (diff < 2) addUnavail(sd);
  sd.setDate(sd.getDate() + 7);

  return new Date(Math.max(permitMonday, sd));
};

const getViewStartDate = () => {
  var date = new Date($('#calendar').fullCalendar('getView').start._d);
  date.setHours(8, 0, 0, 0);
  return date;
};

const getViewEndDate = () => {
  var date = new Date($('#calendar').fullCalendar('getView').end._d);
  date.setHours(8, 0, 0, 0);
  return date;
};

const getLastScheduleDay = () => {
  return new Date(Math.max.apply(null, schedules.map(x => x.end)));
};

const dateFromString = s => {
  var re = /(\d\d\d\d)-(\d\d)-(\d\d)T(\d\d):(\d\d):(\d\d)Z/;
  var mr = s.match(re);
  return new Date(mr[1], (+mr[2]) - 1, mr[3], mr[4], mr[5], mr[6]);
};

const changeMonth = () => {
  var t = $('#calendar').fullCalendar('getView').title.split(' ');
  var d = new Date(t[1], monthNames.indexOf(t[0]), 1, 8, 0, 0, 0);
  if (d > startDate && visitedMonth.indexOf(d.getFullYear() + '-' + d.getMonth()) == -1) {
    d = new Date(Math.max(d, getLastScheduleDay()));
    clickModel.Start = d;
    clickModel.End = getViewEndDate();
    callClick();
  } else {
    cal.loadCalendar();
  }
};

const callClick = () => {
  const s1 = clickModel.Start;
  // var e2 = clickModel.End;
  // var sds = findDays(6, s1);
  // if (sds.length > 3) {
  //   var e1 = sds[2];
  //   var s2 = new Date(e1);
  //   s2.setDate(e1.getDate() + 2);
  //   s2.setHours(8, 0, 0, 0);

  //   _callClick({ ...clickModel, End: e1 });

  //   _callClick({ ...clickModel, Start: s2, End: e2 });
  // }
  // else {
  _callClick(clickModel);
  // }
  visitedMonth.push(s1.getFullYear() + '-' + s1.getMonth());
};

const cal = {
  config: {
    height: 500,
    editable: false,
    header: {
      left: 'prev',
      center: 'title',
      right: 'next'
    },
    eventClick: function (event, jsEvent) {
      cal.selectEvent(event);
    },
    eventRender: function (event, element, view) {
      element.addClass('btn-success');
    },
    viewRender: function (view, element) {
      var prevButton = $('.fc-prev-button');
      if (moment().isAfter(view.start)) prevButton.addClass('fullCalendar-hide');
      else prevButton.removeClass('fullCalendar-hide');
    },
    dayRender: function (date, cell) {
      if (moment().isAfter(date)) $(cell).addClass('fullCalendar-disabled');
    },
  },

  init: p => {
    if (inited) return;
    inited = true;

    $('#calendar').fullCalendar(cal.config);
    $('.fc-next-button').click(changeMonth);
    $('.fc-prev-button').click(changeMonth);

    if (dateSelected) {
      cal.loadCalendar(() => {
        if (dateSelected !== 'custom')
          $('span:contains(' + dateSelected.title + ')').parent().addClass('btn-default selectedEvent');
      });
      return;
    }

    _callClick = p.callClick;
    _selectDate = p.dateSelected;
    _unselectDate = p.dateUnselected;
    prj = p.project.data;
    parcel = p.parcel.data;
    address = p.address;

    if (!p.moveoutDate || p.moveoutDate === '9999-12-31')
      moveoutDate = new Date();
    else
      moveoutDate = new Date(...p.moveoutDate.split('-').map((x, i) => i === 1 ? x - 1 : x));

    moveoutDate.setHours(8, 0, 0, 0);

    schedules = [];
    staticEvents = [];

    setMaxPermitDuration(parcel.permits);
    startDate = getStartDate();
    $('#calendar').fullCalendar('gotoDate', startDate);
    clickModel = {
      GeoCode: parcel.whereAmIInfo.dispatchArea,
      WorkCenter: prj.workCenter,
      Duration: prj.duration,
      PostCode: address.postCode,
      Street: address.streetNumber + ' ' + address.streetName + ' ' + address.streetType,
      City: address.city,
      Province: address.province,
      ProjectNo: prj.projectNo,
      ServiceCode: p.projectModel.ProductType == 1 ? '105' : '101',
      IsConversion: !p.projectModel.CafeData.IsNewBuilding,
      InstallType: parcel.installFrom,
      MainPressure: parcel.mainInfo.mainPressure,
      IsSingleMeter: true,
      IsLondSide: parcel.mainInfo.longSideService,
      Start: startDate,
      FuncLoc: p.project.data.funcLoc,
      End: getViewEndDate()
    };
    callClick();
  },

  selectEvent: event => {
    if (event.isPermit || event.isUnavail) return;

    dateSelected = event;

    $('span.fc-title').each(function (i, x) { $(x).parent().removeClass('btn-default selectedEvent'); });
    $('span:contains(' + event.title + ')').parent().addClass('btn-default selectedEvent');

    var s = {};
    s.scheduleStartDate = new Date(event.start._i);
    s.scheduleEndDate = new Date(s.scheduleStartDate);
    s.scheduleEndDate.setDate(s.scheduleStartDate.getDate() + 5);
    s.clickStartDate = new Date(Math.max(startDate, getViewStartDate()));
    s.clickEndDate = getViewEndDate();

    var s1 = s.scheduleStartDate;
    var enddate = new Date(s.scheduleEndDate.getTime());
    enddate.setDate(enddate.getDate() - 1);
    var e1 = enddate;

    s.dateSelected = days[s1.getDay()] + ' ' + monthNames[s1.getMonth()] + ' ' + s1.getDate() + ' - ' + days[e1.getDay()] + ' ' + monthNames[e1.getMonth()] + ' ' + e1.getDate();

    _selectDate(s);
  },

  unselectEvent: () => {
    $('span.fc-title').each(function (i, x) { $(x).parent().removeClass('btn-default selectedEvent'); });
    dateSelected = 'custom';
    _unselectDate();
  },

  // removeDuplicates: origArr => {
  //   var newArr = [],
  //     origLen = origArr.length,
  //     found, x, y;
  //   for (x = 0; x < origLen; x++) {
  //     found = undefined;
  //     for (y = 0; y < newArr.length; y++) {
  //       var oDate = new Date(origArr[x]._start);
  //       var nDate = new Date(newArr[y]._start);
  //       if (oDate.getTime() == nDate.getTime() && (origArr[x].isUnavail || origArr[x].isPermit)) {
  //         found = true;
  //         break;
  //       }
  //     }
  //     if (!found) {
  //       newArr.push(origArr[x]);
  //     }
  //   }
  //   return newArr;
  // },
  loadCalendar: f => {
    setTimeout(() => {
      $('#calendar').fullCalendar('removeEvents');
      // Add 2 days to start on Monday
      let viewStartDate = addDays(getViewStartDate(), 2);
      const viewEndDate = getViewEndDate();

      const finalSchedules = [];
      while (addDays(viewStartDate, 6) <= viewEndDate) {
        let currentWeek;
        currentWeek = schedules.find(day => day.start.getMonth() === viewStartDate.getMonth()
          && day.start.getDate() === viewStartDate.getDate() && day.isAvail);
        if (currentWeek) {
            finalSchedules.push(currentWeek); 
        } else {
          finalSchedules.push( {
            start: viewStartDate,
            end: addDays(viewStartDate, 5),
            isAvail: false
          });
        }
        viewStartDate = addDays(viewStartDate, 7);
      }
      // schedules.map((x, i) => {
      //   var startDate = new Date(x.start);
      //   var endDate = new Date(x.end);
      //   var nextStartDate = schedules[i + 1] && schedules[i + 1].start ? schedules[i + 1].start : null;
      //   if (nextStartDate == null)
      //     return;
      //   var newDate = new Date(startDate);
      //   newDate.setDate(newDate.getDate() + 7);
      //   if (newDate.getDate() != nextStartDate.getDate())
      //   finalSchedules.push({ start: newDate, end: endDate.setDate(newDate.getDate() + 5), isUnavail: true })
      // });


      finalSchedules.forEach(val => {
        var startDate = new Date(val.start);
        var endDate = new Date(val.end);

        var ds = startDate.getDate();
        var ms = startDate.getMonth();
        var ys = startDate.getFullYear();
        var smonth = monthNames[ms];

        // endDate.setDate(endDate.getDate());
        var de = endDate.getDate();
        var me = endDate.getMonth();
        var ye = endDate.getFullYear();
        var emonth = monthNames[me];

        // endDate.setDate(endDate.getDate());
        var dd = endDate.getDate();
        var md = endDate.getMonth();
        var yd = endDate.getFullYear();
        var dmonth = monthNames[md];

        var event = {
          start: new Date(ys, ms, ds),
          end: new Date(ye, me, de),
          allDay: true
        };

        var bgColor = 'rgb(244, 244, 244)';
        var bdColor = 'rgb(128, 128, 128)';
        var txtColor = 'rgb(80, 80, 80)';
        // if (val.isPermit) {
        //   event.isPermit = true;
        //   //event.title = 'Permitting and lead time';
        //   event.title = 'Unavailable';
        //   event.backgroundColor = bgColor;
        //   event.borderColor = bdColor;
        //   event.textColor = txtColor;
        // } else 
        
        if (val.isAvail) {
          event.title = 'Select: ' + smonth + ' ' + ds + ' - ' + dmonth + ' ' + (dd);
          event.end.setDate(event.end.getDate() + 1);
        } else {
          event.isUnavail = true;
          // event.end.setDate(event.end.getDate() );
          event.title = 'Unavailable';
          event.backgroundColor = bgColor;
          event.borderColor = bdColor;
          event.textColor = txtColor;
        }

        if (staticEvents.filter(x => x.start.getTime() === event.start.getTime() && x.title == event.title).length == 0)
          staticEvents.push(event);
      });

      staticEvents.forEach(x => $('#calendar').fullCalendar('renderEvent', x));
      // var events = $('#calendar').fullCalendar("clientEvents");
      // // console.log(events);
      // // var newEvents = cal.removeDuplicates(events);
      // // console.log(events);
      // $('#calendar').fullCalendar('removeEvents');
      // events.forEach(x => $('#calendar').fullCalendar('renderEvent', x));

      if (f) f();
    }, 1000);


    // $('#calendar').fullCalendar( 'refetchEvents' );
  },
  parseSchedule: a => {
    const isAvail = a && a[0];
    if (!isAvail)
      return;
    const sd = a[0].start;
    const ed = a[0].end;
    const appointments = a;

    var ds = findDays(1, sd, ed);

    if (appointments) {
      var ss = appointments.map(x => x.start);
      ss = ss.map(x => dateFromString(x).getTime());
      ds = ds.filter(x => ss.indexOf(x.getTime()) == -1);
    }
    ds.forEach(x => {
      var e = new Date(x);
      e.setDate(e.getDate() + 6);
      schedules.push({ start: x, end: e, isUnavail: true });
    });
    schedules = schedules.concat(appointments.map(x => {
      return { start: dateFromString(x.start), end: dateFromString(x.end), isAvail: true };
    }));
    //dispatch({ type: 'SCHEDULES', schedules });
    cal.loadCalendar();
  },

  clear: keepEvents => {
    inited = false;
    if (!keepEvents) {
      $('#calendar').fullCalendar('removeEvents');
      dateSelected = null;
    }
  }
}

export default cal;
